module.exports = __webpack_public_path__ + "static/media/rotate-left.2c15d537.svg";